import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adm, apiErr } from "../../lib/adminApi";
import { PageHead, Btn, Card, Badge } from "../../components/admin/ui";

export default function AdminSupporters() {
  const [items, setItems] = useState([]);
  const refresh = () => adm.supporters().then(setItems).catch(() => {});
  useEffect(() => { refresh(); }, []);

  const review = async (p, status) => {
    try { await adm.reviewSupporter(p.id, status); toast.success(`Profile ${status}.`); refresh(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  const tone = (s) => (s === "approved" ? "green" : s === "rejected" ? "red" : "gold");

  return (
    <div data-testid="admin-supporters">
      <PageHead title="Supporters" sub="Opt-in public recognition. Only approved, member-chosen fields ever appear publicly — never emails, orders or billing data." />
      {items.length === 0 && <p className="text-white/40 text-sm">No supporter profiles submitted yet.</p>}
      {items.map((p) => (
        <Card key={p.id} className="mb-3" >
          <div className="flex flex-wrap items-center justify-between gap-4" data-testid={`supporter-row-${p.id}`}>
            <div>
              <p className="text-white/90">{p.displayName} <span className="font-mono text-[9px] text-gold ml-2">{p.designation?.toUpperCase()}</span></p>
              <p className="font-mono text-[9px] text-white/40 mt-1">
                {p.platform ? `${p.platform} ${p.handle}` : "no social"} · {p.link || "no link"} · visibility: {p.visibility}
              </p>
              <p className="font-mono text-[8px] text-white/25 mt-1">account: {p.accountEmail} (admin-only)</p>
            </div>
            <div className="flex items-center gap-2">
              <Badge tone={tone(p.approvalStatus)}>{p.approvalStatus}</Badge>
              {p.approvalStatus !== "approved" && <Btn onClick={() => review(p, "approved")} testid={`supporter-approve-${p.id}`}>APPROVE</Btn>}
              {p.approvalStatus !== "rejected" && <Btn variant="danger" onClick={() => review(p, "rejected")} testid={`supporter-reject-${p.id}`}>REJECT</Btn>}
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
